import type { EstimationModelItemGroupResponse } from '@/api/schema/data-contracts';

import type { EstimationItemsFormModelRow } from '../model';
import type { ResourceEstimationItemsTableRecord } from '../model';
import type { FormModelItemWithOriginalData } from './model';

export const mapFormModelItemWithOriginalData = (
  formModelEstimationItems: EstimationItemsFormModelRow[],
  estimationItems: ResourceEstimationItemsTableRecord[],
  group: EstimationModelItemGroupResponse | undefined,
): FormModelItemWithOriginalData[] => {
  if (!group) {
    return [];
  }

  return formModelEstimationItems
    .filter((x) => x.groupId === group?.id)
    .map((formModelItem) => ({
      id: formModelItem.id,
      formModelItemIndex: formModelEstimationItems.findIndex((x) => x.id === formModelItem.id),
      formModelItem,
      originalData: estimationItems.find(
        (estimationItem) => estimationItem.id === formModelItem.id,
      ),
    }));
};
